import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./components/Navbar";
// import OurOffer from "./components/OurOffer";
import Footer from "./components/Footer";
import Testimonials from "./components/Testimonials";
import Modal from "./Modal";
// import FloatingImage from "./assests/AIicon.png";
import FloatingAIButton from "./components/FloatingAIButton";
import aboutImg from "./assests/about.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBullseye, faEye, faHandshake } from "@fortawesome/free-solid-svg-icons";
import "./AboutUs.css"; // Import new styles

const AboutUs = () => {
  const navigate = useNavigate();
  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);

  const [pageData] = useState({
    title: "About Us",
    mainContent: {
      heading: "Travel Made Easy",
      subheading: "Plan Your Trip With Trippro",
      description:
        "Discover a hassle-free way to plan your next adventure with Trippro. Whether you're seeking thrilling destinations or peaceful retreats, we’re here to make your journey seamless and memorable.",
      bulletPoints: [
        {
          title: "Mission",
          icon: faBullseye,
          description:
            "Empower travelers with AI-driven personalized holiday planning, making travel seamless, customized, and hassle-free.",
        },
        {
          title: "Vision",
          icon: faEye,
          description:
            "To be the go-to platform for self-designed travel experiences, offering flexibility, affordability, and convenience.",
        },
        {
          title: "Objective",
          icon: faHandshake,
          description:
            "Bridge the gap between traditional package tours and fully customized travel, giving users complete control over their trips.",
        },
      ],
    },
    images: [
      {
        src: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?q=80&w=2621&auto=format&fit=crop",
        alt: "Journey",
      },
    ],
  });

  return (
    <>
      <Navbar />

      {/* Hero Section */}
      <div className="about-hero">
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content">
          <h1>{pageData.title}</h1>
          <p>Redefining how the world travels, one journey at a time.</p>
        </div>
      </div>

      <div className="about-container">
        {/* Intro Section */}
        <div className="about-intro">
          <div className="about-image-stack">
            <img
              src={pageData.images[0].src}
              alt="About Trippro"
              className="about-image-main"
            />
          </div>

          <div className="about-text">
            <span className="subtitle">{pageData.mainContent.heading}</span>
            <h2>{pageData.mainContent.subheading}</h2>
            <p>{pageData.mainContent.description}</p>
            <button className="book-now-btn" onClick={() => navigate("/")}>
              Start Planning
            </button>
          </div>
        </div>

        {/* Mission/Vision Grid */}
        <div className="mission-grid">
          {pageData.mainContent.bulletPoints.map((point, index) => (
            <div className="mission-card" key={index}>
              <div className="mission-icon">
                <FontAwesomeIcon icon={point.icon} />
              </div>
              <h3>{point.title}</h3>
              <p>{point.description}</p>
            </div>
          ))}
        </div>

        {/* Gallery Strip */}
        <div className="gallery-strip">
          <img
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&auto=format&fit=crop&q=60"
            alt="Team"
            className="gallery-img"
          />
          <img
            src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&auto=format&fit=crop&q=60"
            alt="Meeting"
            className="gallery-img"
          />
          <img
            src="https://images.unsplash.com/photo-1517048676732-d65bc937f952?w=600&auto=format&fit=crop&q=60"
            alt="Office"
            className="gallery-img"
          />
        </div>
      </div>

      {/* Components */}
      {/* <OurOffer /> */}
      <Testimonials />

      <Footer />

      {/* Floating Button */}
      <FloatingAIButton onClick={openModal} />

      {isModalOpen && <Modal closeModal={closeModal} />}
    </>
  );
};

export default AboutUs;
